import { render } from "./IntegracaoInternaPj.vue?vue&type=template&id=4f6f6109"
import script from "./IntegracaoInternaPj.vue?vue&type=script&lang=js"
export * from "./IntegracaoInternaPj.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__